module.exports = __webpack_public_path__ + "img/target.10c63764.svg";